import { forwardRef } from "react";
import { Turnstile as CFTurnstile } from "@marsidev/react-turnstile";

export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";

// Thin wrapper over the maintained, StrictMode-safe @marsidev/react-turnstile widget.
// Preserves our contract: onToken(token|""), action, and ref.reset() to request a fresh token.
export const Turnstile = forwardRef(function Turnstile({ onToken, action = "login", className }, ref) {
  if (!TURNSTILE_SITE_KEY) return null;
  return (
    <div className={className} data-testid="turnstile-widget">
      <CFTurnstile
        ref={ref}
        siteKey={TURNSTILE_SITE_KEY}
        options={{ action, theme: "light" }}
        onSuccess={(token) => onToken && onToken(token)}
        onError={() => onToken && onToken("")}
        onExpire={() => onToken && onToken("")}
      />
    </div>
  );
});
